import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../assets/css/about-video.css";

const aboutBoxes = [
  {
    id: 1,
    icon: "las la-shoe-prints",
    title: "Sifat",
    desc: "Har bir poyabzal yuqori sifatli materiallardan tayyorlangan va har bir detalga e'tibor berilgan",
  },
  {
    id: 2,
    icon: "las la-heart",
    title: "Qulaylik va Uslub",
    desc: "Biz chiroyli poyabzallar ko'rinishi kabi qulay bo'lishi kerak deb ishonamiz",
  },
  {
    id: 3,
    icon: "las la-globe",
    title: "Xalqaro",
    desc: "Dunyoning eng mashhur va sifatli poyabzallarini O'zbekistonga keltiramiz",
  },
];

const About = () => {
  return (
    <section className="about-section sp-t" id="about">
      <Container>
        <Row>
          <Col lg={8} className="mb-5 mx-auto text-center">
            {/* - Section Heading - */}
            <div className="section-heading">
              <div className="sub-heading">
                <p>Bizning Hikoyamiz</p>
              </div>
              <div className="heading-title">
                <h2>2024 yildan beri sifatli xizmat ko'rsatmoqdamiz</h2>
              </div>
              <div className="heading-description">
                <p>
                  Biz klassik nafislik va zamonaviy innovatsiyalarni o'zida mujassam etgan poyabzallarni
                  yetkazib berishga ishtiyoqmandmiz.
                </p>
              </div>
            </div>
            {/* - Section Heading - */}
          </Col>
        </Row>

        {/* - About Data Display - */}
        <Row className="values-row">
          {(aboutBoxes || []).map((box) => (
            <Col key={box.id} lg={4} className="mb-lg-0 mb-4 text-center">
              <div className="iconbox-primary value-box">
                <div className="item-icon mb-4">
                  <i className={box.icon}></i>
                </div>
                <div className="item-content">
                  <h3>{box.title}</h3>
                  <p>{box.desc}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        {/* - About Data Display - */}

        {/* - Brand Story - */}
        <Row className="mt-5 brand-story">
          <Col lg={6} className="mb-lg-0 mb-4">
            <div className="about-video">
              <div className="video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/ZFPvY-EWLr4"
                  title="About Us Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="rounded-3 shadow-sm"
                ></iframe>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="about-content">
              <h3>Bizning Falsafamiz</h3>
              <p>
                VELVET do'konida biz har bir inson qayerda bo'lishidan qat'i nazar, yuqori sifatli poyabzallarga ega bo'lishi kerak deb hisoblaymiz. Shuning uchun biz o'z brendimizni dunyo bo'ylab eng yaxshi poyabzallarni to'g'ridan-to'g'ri sizning eshigingizgacha olib kelish g'oyasi asosida qurdik.
              </p>
              <p>
                Bizning vazifamiz oddiy: xalqaro miqyosda tanlab olingan ajoyib poyabzallarni tezlik, xavfsizlik va g'amxo'rlik bilan yetkazib berish. Biz taklif qilgan har bir juft poyabzal sifat, uslub va ishonchga bo'lgan sadoqatimizni aks ettiradi.
              </p>
              <p>
                Biz xarid qilishdan tortib yetkazib berishgacha bo'lgan jarayonni qulay bo'lishini ta'minlash uchun yetakchi ta'minotchilar va logistika hamkorlarimiz bilan yaqindan hamkorlik qilamiz — shunda siz ishonch bilan qadam tashlaysiz.
              </p>
            </div>
          </Col>
        </Row>
        {/* - Brand Story - */}
      </Container>
    </section>
  );
};

export default About;
